import StoryblokClient from "storyblok-js-client";

let Storyblok = new StoryblokClient({
  accessToken: "q53wjs4yTcLOyiW1e1WDZAtt",
});

export default Storyblok;
